module.exports = __webpack_public_path__ + "img/diesel-locomotive-02.f04c7a05.png";